import { render, staticRenderFns } from "./OverviewPage.vue?vue&type=template&id=a430fb04&"
import script from "./OverviewPage.vue?vue&type=script&lang=js&"
export * from "./OverviewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports